<template>
	<div class="keywords-related-main-div" v-loading="loading">
		<div class="search-bar" v-if="!keywords">
			<el-input v-model="search.search_term" placeholder="输入关键字搜索">
				<el-button slot="append" icon="el-icon-search" @click="loadData(null)"></el-button>
			</el-input>
		</div>
		<div class="body-div">
			<div class="table-div">
				<el-table :data="searchData.results" v-if="searchData.search" height="100%" :header-cell-style="{'background-color':'#f2f4f8'}">
					<el-table-column label="关键字" prop="search_term" min-width="200">
						<template slot-scope="scope">
							<div style="display: flex;font-weight: bolder;" class="color-text-blue" >
								<div class="overflow-one-line">{{ scope.row.search_term }}</div>
								<copy-sub style="margin-left: 5px" :value="scope.row.search_term"></copy-sub>
							</div>
							<div class="overflow-one-line">
								{{ searchData.translations[scope.row.search_term] }}
							</div>
						</template>
					</el-table-column>

					<el-table-column width="100" prop="search_frequency_rank" label="搜索排名" header-align="center" align="right"></el-table-column>

					<el-table-column label="排名趋势" header-align="center" align="right" width="120">
						<template slot-scope="scope">
							<chart-sub :data_height="50"
								:option="getChartOption(scope.row.search_frequency_rank_growth_metrics)"></chart-sub>
						</template>
					</el-table-column>

					<el-table-column label="点击总占比" width="70" prop="results" header-align="center" align="right">
						<template slot-scope="scope">
							<font>
								{{ toPercent(scope.row.click_share_sum)  }}
							</font>
						</template>
					</el-table-column>

					<el-table-column label="转化总占比" width="70" prop="results" header-align="center" align="right">
						<template slot-scope="scope">
							<font>
								{{ toPercent(scope.row.conversion_share_sum) }}
							</font>
						</template>
					</el-table-column>

					<el-table-column width="80" align="center" fixed="right" label="添加追踪" v-if="addedKeywords">
						<template slot-scope="scope">
							<el-button :disabled="addedKeywords.indexOf(scope.row.search_term) !== -1"
								@click="addKeywords(scope.row.search_term)" circle size="small" icon="el-icon-plus"
								type="primary"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="foot-div">
			<el-pagination background layout="prev, pager, next" @current-change="pageChange" hide-on-single-page
				:total="searchData.total" :page-size="search.pageSize" :current-page="search.page"/>
		</div>
	</div>
</template>

<script>
import Chart from "@/components/template/otherSub/hightChartSub";
import { fomatRankTrendsDataMini } from "@/components/config/chart/keywordRankTrendsMini";
import { changeDecimal, toPercent, toThousands } from "@/components/common/utils/fomatNum";
import { getCountryObjByCity } from "@/components/config/countryCodeConfig";
import COPY_SUB from "@/components/template/otherSub/copySub";
import { fomatSearchTrendsData } from "@/components/config/chart/kywordSearchTrendsMini";
import { api_keyword_keywordsRelatedList } from "@/components/api/asinKeyword";
import { api_keywordsRelatedList_monitoring2 } from "@/components/api/keywordsMonitoring2";

export default {
	name: "keywordsRelated",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			loading: false,
			search: {
				page : 1,
				pageSize : 20,
				search_term: '',
			},
			tabTotal : 0,
			searchData: {}
		}
	},
	props: {
		keywords : String,
		addedKeywords: Array,
		country : {
			required: true
		}
	},
	computed:{},
	components: {
		'chart-sub': Chart,
		'copy-sub' : COPY_SUB,
	},
	created() {
		if (this.keywords){
			this.$data.search.search_term = this.keywords
			this.$options.methods.loadData(this)
		}
	},
	methods: {
		addKeywords: function(text) {
			if (!text){
				this.F_alertMsg('添加错误,关键词为空',4)
			}
			this.$emit('addKeywords', null, text)
		},
		getSortDescendingCss : function(sort,selfNum){
			let css = 'sort-cart '
			if (selfNum === 1) {
				css += 'sort-descending '
			} else{
				css += 'sort-ascending '
			}

			if(sort === selfNum){
				css += 'check-sort '
			}
			return css;
		},
		pageChange: function(val) {
			this.$data.search.page = val
			this.$options.methods.loadData(this)
		},
		loadData: function(this_) {
			this_ = this_ || this
			let obj = this_.$data.search
			// 开启遮罩
			this_.$data.loading = true
			this_.$data.searchData.search = { ...obj }
			api_keywordsRelatedList_monitoring2(obj).then(res => {
				this_.$data.searchData = { ...this_.$data.searchData,...res.data }
				// 关闭遮罩c
				this_.$data.loading = false
			}).catch(err => {
				// 关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg('系统繁忙,请稍后再试', 4)
			})
		},
		getChartOption : function(trends) {
			return fomatRankTrendsDataMini(trends)
		},
		toPercent : function(num,size=2) {
			return toPercent(num,size)
		},
		toThousands : function(num){
			return toThousands(num)
		},
		changeDecimal: function(v) {
			return changeDecimal(v)
		},
		getCountryObjByCity: function(val) {
			return getCountryObjByCity(val)
		},
	}
}
</script>

<style scoped>
.keywords-related-main-div {
	height: 100%;
	position: relative;
}

.loading-div {
	line-height: 42px;
	text-align: center;
}
.table-div{
	position: absolute;
	top: 55px;
	left: 0;
	right: 0;
	bottom: 40px;
}
.purchase-mark-div{
	display: inline-block;
	padding: 6px;
	margin: 5px;
	border-radius: 50%;
	background-color: #f57d7d;
	box-shadow: 0px 0px 5px 3px #f57d7d;
}
.check-sort{
	color: #409EFF;
}
.sort-span{
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	width: 20px;
	vertical-align: middle;
	cursor: pointer;
	overflow: initial;
	position: relative;
}
.sort-span .sort-cart{
	width: 0px;
	height: 0px;
	position: absolute;
	left: 4px;
}
.sort-span .sort-ascending{
	bottom: 12px;
}
.sort-span .sort-descending{
	bottom: 4px;
}
.target-a{
	font-size: 16px;
	color: #409EFF;
	margin-right: 10px;
	font-weight: bolder;
	border-bottom:1px dashed transparent;
	cursor: pointer;
	max-width: 70%;
	float: left;
}
.target-a:hover{
	border-bottom:1px dashed  #409EFF;
}
.foot-div {
	text-align: center;
	bottom: 0;
	left: 0;
	right: 0;
	position: absolute;
}
</style>